import { Tooltip } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, fontSize, fontWeight, TypographyStyledGlobal } from '../../../theme';
import { ButtonLabel, ButtonsRow, Container, TemplateButton } from './styled';
import { ReactComponent as Col1 } from '../../../assets/columnTemplates/col1.svg';
import { ReactComponent as Col2W3466 } from '../../../assets/columnTemplates/col2_3466.svg';
import { ReactComponent as Col2W5050 } from '../../../assets/columnTemplates/col2_5050.svg';
import { ReactComponent as Col2W6634 } from '../../../assets/columnTemplates/col2_6634.svg';
import { ReactComponent as Col3W333333 } from '../../../assets/columnTemplates/col3_333333.svg';

interface TemplateSelectorProps {
    selectedConfig: number[]
    onSelect: (config: number[]) => void
}

interface Temmplate {
    key: string
    config: number[]
    label: string
    templateSVG: React.ReactElement
    tooltip: string
}

const ColumnTemplateSelector: FC<TemplateSelectorProps> = ({ selectedConfig, onSelect }) => {
    const { t } = useTranslation('dashboard');

    const TEMPLATES: Temmplate[] = [
        { key: 'template1', config: [100], label: '1', templateSVG: <Col1 key='col1' height={18} width={18} />, tooltip: t('addDashboard.template1col') },
        { key: 'template2c5050', config: [50, 50], label: '2', templateSVG: <Col2W5050 key='col2w5050' height={18} width={18} />, tooltip: t('addDashboard.template2col5050') },
        { key: 'template2c6634', config: [66, 34], label: '2', templateSVG: <Col2W6634 key='col2w6634' height={18} width={18} />, tooltip: t('addDashboard.template2col6634') },
        { key: 'template2c3466', config: [34, 66], label: '2', templateSVG: <Col2W3466 key='col2w3466' height={18} width={18} />, tooltip: t('addDashboard.template2col3466') },
        { key: 'template3c333333', config: [33, 33, 34], label: '3', templateSVG: <Col3W333333 key='col3w333333' height={18} width={18} />, tooltip: t('addDashboard.template3col') },
    ];

    return (
        <Container>
            <TypographyStyledGlobal
                color={colors.grey200}
                margin='8px 0'
                size={fontSize.m}
                weight={fontWeight.regular}
            >
                {t('addDashboard.templateLabel')}
            </TypographyStyledGlobal>
            <ButtonsRow>
                {TEMPLATES.map((template) => {
                    const isSelected = JSON.stringify(selectedConfig) === JSON.stringify(template.config);

                    return (
                        <Tooltip
                            key={template.key}
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        bgcolor: colors.grey100,
                                        borderRadius: '4px',
                                        color: colors.grey000,
                                        fontSize: fontSize.sm,
                                        fontWeight: fontWeight.semiRegular,
                                        maxWidth: 360,
                                        padding: '6px 10px',
                                        '& .MuiTooltip-arrow': { color: colors.grey100 },
                                    },
                                },
                            }}
                            placement="top"
                            title={template.tooltip}
                            arrow
                        >
                            <TemplateButton
                                $selected={isSelected}
                                onClick={() => onSelect([...template.config])}
                                type="button"
                            >
                                {template.templateSVG}
                                <ButtonLabel $selected={isSelected}>{template.label}</ButtonLabel>
                            </TemplateButton>
                        </Tooltip>
                    );
                })}
            </ButtonsRow>
        </Container>
    );
};

export default ColumnTemplateSelector;
